export default __webpack_public_path__ + "static/media/borrowIconDark.93a14239.svg";